module.exports = __webpack_public_path__ + "img/autre-action.ed02964c.svg";